'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var effects = require('redux-saga/effects');
var networkMiddleware = require('@piconetworks/network-middleware');
var endpoints = require('@piconetworks/endpoints');
var Duck = require('extensible-duck');
var reselect = require('reselect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);

var types = ['CREATE_ACCOUNT', 'CREATE_ACCOUNT_SUCCESS', 'CREATE_ACCOUNT_ERROR', 'GET_HAS_PASSWORD', 'GET_HAS_PASSWORD_SUCCESS', 'GET_HAS_PASSWORD_ERROR', 'HAS_PASSWORD_RESET_AUTH', 'REQUEST_LOGIN_LINK', 'REQUEST_LOGIN_LINK_SUCCESS', 'REQUEST_LOGIN_LINK_ERROR', 'SET_LOGIN_EMAIL', 'SET_LOGIN_EMAIL_SUCCESS', 'SET_LOGIN_EMAIL_ERROR', 'REQUEST_PASSWORD_RESET', 'REQUEST_PASSWORD_RESET_SUCCESS', 'REQUEST_PASSWORD_RESET_ERROR', 'NEWSLETTER_SUBSCRIBE', 'NEWSLETTER_SUBSCRIBE_SUCCESS', 'NEWSLETTER_SUBSCRIBE_ERROR', 'USER_JOIN_GROUP', 'USER_JOIN_GROUP_SUCCESS', 'USER_JOIN_GROUP_ERROR', 'UPDATE', 'UPDATE_SUCCESS', 'UPDATE_ERROR', 'CONFIRMATION_EMAIL', 'DELETE_ACCOUNT', 'DELETE_ACCOUNT_SUCCESS', 'DELETE_ACCOUNT_ERROR', 'NEW_USER_REGISTRATION'];

var creators = function creators(duck) {
  return {
    createAccount: function createAccount(payload) {
      return Object.assign({
        type: duck.types.CREATE_ACCOUNT
      }, payload);
    },
    getHasPassword: function getHasPassword(payload) {
      return Object.assign({
        type: duck.types.GET_HAS_PASSWORD
      }, payload);
    },
    hasPasswordResetAuth: function hasPasswordResetAuth(payload) {
      return Object.assign({
        type: duck.types.HAS_PASSWORD_RESET_AUTH
      }, payload);
    },
    requestLoginLink: function requestLoginLink(payload) {
      return Object.assign({
        type: duck.types.REQUEST_LOGIN_LINK
      }, payload);
    },
    setLoginEmail: function setLoginEmail(payload) {
      return Object.assign({
        type: duck.types.SET_LOGIN_EMAIL
      }, payload);
    },
    requestPasswordReset: function requestPasswordReset(payload) {
      return Object.assign({
        type: duck.types.REQUEST_PASSWORD_RESET
      }, payload);
    },
    newsletterSubscribe: function newsletterSubscribe(payload) {
      return Object.assign({
        type: duck.types.NEWSLETTER_SUBSCRIBE
      }, payload);
    },
    userJoinGroup: function userJoinGroup(payload) {
      return Object.assign({
        type: duck.types.USER_JOIN_GROUP
      }, payload);
    },
    update: function update(payload) {
      return Object.assign({
        type: duck.types.UPDATE
      }, payload);
    },
    signupConfirmationEmail: function signupConfirmationEmail(payload) {
      return Object.assign({
        type: duck.types.CONFIRMATION_EMAIL
      }, payload);
    },
    deleteAccount: function deleteAccount(payload) {
      return Object.assign({
        type: duck.types.DELETE_ACCOUNT
      }, payload);
    }
  };
};

var initialState = {
  email: undefined,
  loginEmail: undefined,
  hasPassword: undefined,
  hasPasswordError: undefined,
  isNewRegistration: undefined,
  isFetching: false,
  didJoinGroup: undefined,
  loginLinkSent: false,
  loginLinkError: null,
  passwordResetSent: false,
  passwordResetError: null,
  hasPasswordResetAuth: false,
  updateAccount: {
    isUpdating: false,
    userDataUpdated: null,
    emailDataUpdated: null,
    error: false
  },
  accountDeleted: false
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.HAS_PASSWORD_RESET_AUTH:
        draftState.hasPasswordResetAuth = true;
        break;

      case duck.types.CREATE_ACCOUNT:
        // eslint-disable-next-line no-param-reassign
        draftState = Object.assign({}, duck.initialState, {
          isFetching: true
        });
        break;

      case duck.types.REQUEST_LOGIN_LINK:
        draftState.loginLinkSent = false;
        draftState.isNewRegistration = initialState.isNewRegistration;
        break;

      case duck.types.REQUEST_LOGIN_LINK_SUCCESS:
        draftState.loginLinkSent = true;
        draftState.isNewRegistration = payload.isNewRegistration;
        break;

      case duck.types.REQUEST_LOGIN_LINK_ERROR:
        draftState.loginLinkSent = false;
        draftState.loginLinkError = error.message;
        draftState.isNewRegistration = false;
        break;

      case duck.types.SET_LOGIN_EMAIL:
        draftState.loginEmail = initialState.loginEmail;
        break;

      case duck.types.SET_LOGIN_EMAIL_SUCCESS:
        draftState.loginEmail = payload.loginEmail;
        break;

      case duck.types.SET_LOGIN_EMAIL_ERROR:
        draftState.loginEmail = error.message;
        break;

      case duck.types.REQUEST_PASSWORD_RESET:
        draftState.passwordResetSent = false;
        break;

      case duck.types.REQUEST_PASSWORD_RESET_SUCCESS:
        draftState.passwordResetSent = true;
        break;

      case duck.types.REQUEST_PASSWORD_RESET_ERROR:
        draftState.passwordResetSent = false;
        draftState.passwordResetError = error.message;
        break;

      case duck.types.GET_HAS_PASSWORD:
        draftState.hasPassword = initialState.has_password;
        draftState.isFetching = true;
        break;

      case duck.types.GET_HAS_PASSWORD_SUCCESS:
        draftState.hasPassword = payload.has_password;
        draftState.isFetching = false;
        break;

      case duck.types.GET_HAS_PASSWORD_ERROR:
        draftState.isFetching = false;
        draftState.hasPasswordError = error;
        break;

      case duck.types.CREATE_ACCOUNT_SUCCESS:
        draftState.isFetching = false;
        draftState.isNewRegistration = payload.isNewRegistration;
        break;

      case duck.types.CREATE_ACCOUNT_ERROR:
        draftState.isFetching = false;

        if (error.hasPassword !== undefined && error.email) {
          draftState.email = error.email;
          draftState.hasPassword = error.hasPassword;
        }

        if (error.isNewRegistration !== undefined && error.email) {
          draftState.email = error.email;
          draftState.isNewRegistration = error.isNewRegistration;
        }

        break;

      case duck.types.USER_JOIN_GROUP_SUCCESS:
        draftState.didJoinGroup = true;
        break;

      case duck.types.USER_JOIN_GROUP_ERROR:
        draftState.didJoinGroup = false;
        break;

      case duck.types.UPDATE:
        draftState.updateAccount.isUpdating = true;
        draftState.updateAccount.error = false;
        break;

      case duck.types.UPDATE_SUCCESS:
        draftState.updateAccount.isUpdating = false;
        draftState.updateAccount.userDataUpdated = !!payload.userDataUpdated;
        draftState.updateAccount.emailDataUpdated = !!payload.emailDataUpdated;
        break;

      case duck.types.UPDATE_ERROR:
        draftState.updateAccount.isUpdating = false;

        if (payload.userDataUpdated !== undefined) {
          draftState.updateAccount.userDataUpdated = !!payload.userDataUpdated;
        }

        if (payload.emailDataUpdated !== undefined) {
          draftState.updateAccount.emailDataUpdated = !!payload.emailDataUpdated;
        }

        draftState.updateAccount.error = error;
        break;

      case duck.types.CONFIRMATION_EMAIL:
        draftState.email = payload.email;
        break;

      case duck.types.DELETE_ACCOUNT_SUCCESS:
        draftState.accountDeleted = true;
        break;

    }
  });
};

function* createAccount(_ref) {
  var types = _ref.types,
      email = _ref.email,
      publisher_id = _ref.publisher_id,
      company_slug = _ref.company_slug;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.OAUTH_USER(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherId: publisher_id
        },
        timeout: 30000,
        params: {
          email: email
        }
      }
    }),
        oauthUserData = _yield$putResolve.data;

    if (oauthUserData.has_password) {
      throw {
        email: email,
        hasPassword: true
      };
    }

    var _yield$putResolve2 = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.OAUTH_USER_LINK(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisher_id
        },
        timeout: 30000,
        data: {
          return_token: true,
          articleId: null,
          email: email,
          newsletter_ids: [],
          redirectUrl: "".concat(window.location.origin, "/").concat(company_slug, "/login/token")
        }
      }
    }),
        oauthUserLinkData = _yield$putResolve2.data;

    if (!oauthUserLinkData.isNewRegistration) {
      throw {
        email: email,
        hasPassword: false,
        isNewRegistration: false
      };
    }

    yield effects.putResolve({
      type: networkMiddleware.STORE_TOKENS,
      data: oauthUserLinkData
    });
    yield effects.put({
      type: types.CREATE_ACCOUNT_SUCCESS,
      payload: Object.assign({}, oauthUserLinkData)
    });
  } catch (error) {
    yield effects.put({
      type: types.CREATE_ACCOUNT_ERROR,
      error: error.message
    });
  }
}

function* getHasPassword(_ref) {
  var types = _ref.types,
      email = _ref.email,
      publisherId = _ref.publisherId;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.OAUTH_USER(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherId: publisherId
        },
        timeout: 30000,
        params: {
          email: email
        }
      }
    }),
        data = _yield$putResolve.data;

    if (data.error) {
      throw new Error('Error occured!');
    }

    yield effects.put({
      type: types.GET_HAS_PASSWORD_SUCCESS,
      payload: Object.assign({}, data)
    });
  } catch (error) {
    yield effects.put({
      type: types.GET_HAS_PASSWORD_ERROR,
      error: error.message
    });
  }
}

function* newsletterSubscribe(_ref) {
  var types = _ref.types,
      newsletterIds = _ref.newsletterIds,
      publisherId = _ref.publisherId,
      sync = _ref.sync,
      _ref$onlyAddNewslette = _ref.onlyAddNewsletters,
      onlyAddNewsletters = _ref$onlyAddNewslette === void 0 ? false : _ref$onlyAddNewslette,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.NEWSLETTERS_SUBSCRIBE(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          newsletters: newsletterIds,
          sync: sync,
          publisherId: publisherId,
          only_add_newsletters: onlyAddNewsletters
        }
      }
    }),
        data = _yield$putResolve.data;

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.NEWSLETTER_SUBSCRIBE_SUCCESS,
      payload: Object.assign({}, data)
    });
  } catch (error) {
    yield effects.put({
      type: types.NEWSLETTER_SUBSCRIBE_ERROR,
      error: error.message
    });
  }
}

function* requestLoginLink(_ref) {
  var articleId = _ref.articleId,
      customProperties = _ref.customProperties,
      email = _ref.email,
      newsletters = _ref.newsletters,
      origin = _ref.origin,
      popupId = _ref.popupId,
      publisherId = _ref.publisherId,
      redirectUrl = _ref.redirectUrl,
      referer = _ref.referer,
      types = _ref.types,
      utm = _ref.utm,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.OAUTH_USER_LINK(),
        params: Object.assign({}, !!utm && {
          utm: utm
        }),
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        }, !!referer && {
          prev_page: referer
        }, !!origin && {
          'current-url': origin
        }),
        timeout: 30000,
        data: {
          return_token: true,
          article_id: articleId,
          form_id: popupId,
          email: email,
          newsletter_ids: newsletters,
          custom_properties: customProperties,
          redirect_url: redirectUrl
        }
      }
    }),
        data = _yield$putResolve.data;

    if (data.isNewRegistration) {
      yield effects.putResolve({
        type: networkMiddleware.STORE_TOKENS,
        data: data
      });
      yield effects.put({
        type: types.NEW_USER_REGISTRATION
      });
      yield effects.put(yield effects.call(loaderInvalidationEvent, {
        payload: {
          scope: ['user']
        }
      }));
    }

    yield effects.put({
      type: types.REQUEST_LOGIN_LINK_SUCCESS,
      payload: Object.assign({}, data)
    });
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      yield effects.put({
        type: types.REQUEST_LOGIN_LINK_ERROR,
        error: error.response.data
      });
    } else {
      yield effects.put({
        type: types.REQUEST_LOGIN_LINK_ERROR,
        error: error.message
      });
    }
  }
}

function* setLoginEmail(_ref) {
  var email = _ref.email,
      types = _ref.types;

  try {
    yield effects.put({
      type: types.SET_LOGIN_EMAIL_SUCCESS,
      payload: {
        loginEmail: email
      }
    });
  } catch (error) {
    var _error$response, _error$response$data;

    if (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && _error$response$data.message) {
      yield effects.put({
        type: types.SET_LOGIN_EMAIL_ERROR,
        error: error.response.data
      });
    } else {
      yield effects.put({
        type: types.SET_LOGIN_EMAIL_ERROR,
        error: error.message
      });
    }
  }
}

function* requestPasswordReset(_ref) {
  var types = _ref.types,
      publisherId = _ref.publisherId,
      email = _ref.email,
      redirectUrl = _ref.redirectUrl;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'put',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.OAUTH_USER_RESET(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          redirectUrl: redirectUrl,
          email: email,
          publisherId: publisherId
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data.success) {
      throw new Error('unable to request password reset');
    }

    yield effects.put({
      type: types.REQUEST_PASSWORD_RESET_SUCCESS,
      payload: Object.assign({}, data)
    });
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      yield effects.put({
        type: types.REQUEST_PASSWORD_RESET_ERROR,
        error: error.response.data
      });
    } else {
      yield effects.put({
        type: types.REQUEST_PASSWORD_RESET_ERROR,
        error: error.message
      });
    }
  }
}

function* update(_ref) {
  var types = _ref.types,
      firstName = _ref.first_name,
      lastName = _ref.last_name,
      email = _ref.email,
      password = _ref.password,
      oldPassword = _ref.oldPassword,
      publisherId = _ref.publisherId,
      hasPasswordResetAuth = _ref.hasPasswordResetAuth,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;
  var userData;
  var userPayload = Object.assign({}, firstName && {
    first_name: firstName
  }, lastName && {
    last_name: lastName
  }, email && {
    email: email
  }, password && !hasPasswordResetAuth && Object.assign({}, oldPassword && {
    old_password: oldPassword
  }, password && {
    new_password: password
  }));

  try {
    if (Object.keys(userPayload).length) {
      var _yield$putResolve = yield effects.putResolve({
        type: networkMiddleware.REQUEST,
        config: {
          method: 'put',
          baseURL: endpoints.PICO_API_URL(),
          url: endpoints.ME(),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            publisherid: publisherId
          },
          timeout: 30000,
          data: userPayload
        }
      }),
          data = _yield$putResolve.data;

      userData = data;

      if (!userData) {
        throw Error('no user data');
      }

      yield effects.put(yield effects.call(loaderInvalidationEvent, {
        payload: {
          scope: ['user']
        }
      }));
    }

    if (password && hasPasswordResetAuth) {
      var _yield$putResolve2 = yield effects.putResolve({
        type: networkMiddleware.REQUEST,
        config: {
          method: 'put',
          baseURL: endpoints.PICO_API_URL(),
          url: endpoints.OAUTH_USER(),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            publisherid: publisherId
          },
          timeout: 30000,
          data: Object.assign({}, password && {
            password: password
          }, {
            adBlocking: false,
            origin: window.location.href,
            prev_page: '',
            publisherId: publisherId,
            taxonomies: {}
          })
        }
      }),
          _data = _yield$putResolve2.data;

      userData = _data;

      if (!userData) {
        throw Error('no user data');
      }
    }

    yield effects.put({
      type: types.UPDATE_SUCCESS,
      payload: Object.assign({}, userData && {
        userDataUpdated: true
      }, email && {
        emailDataUpdated: true
      })
    });
  } catch (error) {
    if (error.response && error.response.data) {
      yield effects.put({
        type: types.UPDATE_ERROR,
        error: error.response.data,
        payload: Object.assign({}, (firstName || lastName || password) && {
          userDataUpdated: false
        }, email && {
          emailDataUpdated: false
        })
      });
    } else {
      yield effects.put({
        type: types.UPDATE_ERROR,
        error: error.message
      });
    }
  }
}

function* userJoinGroup(_ref) {
  var types = _ref.types,
      code = _ref.code,
      groupId = _ref.groupId,
      publisherId = _ref.publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    var requestData = {
      group_id: groupId,
      publisherId: publisherId
    };

    if (code) {
      requestData.code = code;
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.GROUPS_USER(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: requestData
      }
    }),
        data = _yield$putResolve.data;

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.USER_JOIN_GROUP_SUCCESS,
      payload: Object.assign({}, data)
    });
  } catch (error) {
    yield effects.put({
      type: types.USER_JOIN_GROUP_ERROR,
      error: error.message
    });
  }
}

function* deleteAccount(_ref) {
  var userId = _ref.userId,
      publisherId = _ref.publisherId,
      types = _ref.types;

  try {
    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'delete',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.ME({
          id: userId
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        params: {
          adBlocking: false,
          origin: window.location.href,
          prev_page: '',
          publisherId: publisherId,
          taxonomies: {}
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data.success) {
      throw new Error('delete account error');
    }

    yield effects.put({
      type: types.DELETE_ACCOUNT_SUCCESS,
      payload: {}
    });
  } catch (error) {
    // captureException(error)
    console.log(error);
    yield effects.put({
      type: types.DELETE_ACCOUNT_ERROR,
      error: error
    });
  }
}

var sagas = function sagas(duck) {
  return {
    createAccount: function* createAccount$1(payload) {
      yield createAccount(Object.assign({}, payload, duck));
    },
    getHasPassword: function* getHasPassword$1(payload) {
      yield getHasPassword(Object.assign({}, payload, duck));
    },
    newsletterSubscribe: function* newsletterSubscribe$1(payload) {
      yield newsletterSubscribe(Object.assign({}, payload, duck));
    },
    requestLoginLink: function* requestLoginLink$1(payload) {
      yield requestLoginLink(Object.assign({}, payload, duck));
    },
    setLoginEmail: function* setLoginEmail$1(payload) {
      yield setLoginEmail(Object.assign({}, payload, duck));
    },
    requestPasswordReset: function* requestPasswordReset$1(payload) {
      yield requestPasswordReset(Object.assign({}, payload, duck));
    },
    update: function* update$1(payload) {
      yield update(Object.assign({}, payload, duck));
    },
    userJoinGroup: function* userJoinGroup$1(payload) {
      yield userJoinGroup(Object.assign({}, payload, duck));
    },
    deleteAccount: function* deleteAccount$1(payload) {
      yield deleteAccount(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.CREATE_ACCOUNT, sagas.createAccount), effects.takeEvery(types.GET_HAS_PASSWORD, sagas.getHasPassword), effects.takeEvery(types.REQUEST_LOGIN_LINK, sagas.requestLoginLink), effects.takeEvery(types.SET_LOGIN_EMAIL, sagas.setLoginEmail), effects.takeEvery(types.REQUEST_PASSWORD_RESET, sagas.requestPasswordReset), effects.takeEvery(types.NEWSLETTER_SUBSCRIBE, sagas.newsletterSubscribe), effects.takeEvery(types.USER_JOIN_GROUP, sagas.userJoinGroup), effects.takeEvery(types.UPDATE, sagas.update), effects.takeEvery(types.DELETE_ACCOUNT, sagas.deleteAccount)];
};

var selectors = function selectors() {
  return {
    account: new Duck__default['default'].Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.account;
      };
    }),
    isNewRegistration: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.account, function (_ref) {
        var isNewRegistration = _ref.isNewRegistration;
        return isNewRegistration;
      });
    }),
    email: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.account, function (_ref2) {
        var email = _ref2.email;
        return email;
      });
    }),
    loginEmail: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.account, function (_ref3) {
        var loginEmail = _ref3.loginEmail;
        return loginEmail;
      });
    }),
    isFetching: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.account, function (_ref4) {
        var isFetching = _ref4.isFetching;
        return isFetching;
      });
    }),
    isNotFetching: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.isFetching, function (isFetching) {
        return !isFetching;
      });
    }),
    hasPassword: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.account, function (_ref5) {
        var hasPassword = _ref5.hasPassword;
        return hasPassword;
      });
    })
  };
};

var storeDefault = 'account';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      _ref$selectors = _ref.selectors,
      selectors$1 = _ref$selectors === void 0 ? selectors : _ref$selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors$1
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
